<div class="reveal-publish">
  <div class="row row-padding-reveal client-workflow-status">
    <div class="small-12 medium-12 user-profile-css" style="text-align: center;">
      <div *ngIf="displayLogo" style="margin-bottom: 20px;" class="tp-firm-logo" [ngStyle]="logoBg"></div>
      <div style="font-size: 15px; text-align: left;">
        <div>Please upload your firm logo in PNG/SVG/JPEG format not exceeding 2000X900 pixels.</div>
      </div>
      <section class="upload-area create-post" ng2FileDrop [uploader]="uploader" (onFileDrop)="fileDropOver($event)" (fileOver)="fileOverBase($event)">
        <div class="row upload-choose-btn" style="background: #e5e5e5;border: 1px dashed #848484;padding: 30px 0;" [ngClass]="{'popup-file-over': hasBaseDropZoneOver}">
          <div class="columns medium-12 text-center">
            <label for="resourceUpload" class="button" style="background: transparent;text-decoration: underline;padding: 0px;margin-top: 1rem;color: #14B5F0 !important;font-size: 14px">Upload</label>
            <span style="color: #14B5F0;font-size: 14px;">or Drag and Drop file.</span>
            <input type="file" accept="image/*" id="resourceUpload" (change)="fileDropOver($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader"/>
          </div>
        </div>
      </section>
    </div>
    <div class="row-padding-reveal text-center" style="width: 100%;">
      <button class="button small" style="margin: 0 auto;" (click)="submitLogoDetails()" [disabled]="!imageUrl">SUBMIT</button>
    </div>
  </div>
</div>
